import React from 'react';
import { ILoader } from './type';

export const Loader: React.FC<ILoader> = ({ visible = false }) => {
    if (!visible) return null;

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%'
            }}>
            <img src="/ixyber/vision/static/images/loading_hend.gif" style={{ height: '6em', width: '8em' }} />
            <p style={{ fontSize: '1.2em', marginTop: '1em' }}>Загрузка...</p>
        </div>
    );
};
